import React, { Component } from 'react';
import '../../../stylesheets/document.scss'
import BootstrapTable from 'react-bootstrap-table-next';
import { changePath } from '../../../utils/common';

const WS = String.raw`
var _req = '{"task":"cn","channel":"","token":"' + FEED_TOKEN + '","user": "' + CLIENT_CODE + '","acctid":"' + CLIENT_CODE + '"}'; 

websocketObj.send(_req); 

 
 

// socket_scripts = “EXCHANGE|token” FOR MULTI STOCKS use & to separate them. EX: “nse_cm|2885&nse_cm|1594&nse_cm|11536" OR "nse_cm|236"

var strwatchlistscrips = "nse_cm|2885&nse_cm|1594&nse_cm|11536";

var _req = '{"task":"mw","channel":"' + strwatchlistscrips + '","token":"' + FEED_TOKEN + '","user": "' + CLIENT_CODE + '","acctid":"' + CLIENT_CODE + '"}'; 

websocketObj.send(_req); 

 `
const AK = String.raw`
 {ak: ok, msg:mw, task:mw})
 `

const Sample = String.raw`
 [{"ak":"ok","task":"mw","msg":"mw"}]
 [{"lo":"1797.55","ts":"ACC-EQ","tp":null,"ltp":"1800.05","ltq":"27","bs":"16","tk":"22","ltt":"31\/08\/2017 11:32:01",
 "lcl":null,"tsq":"76435","cng":"-11.15","bp":"1800.00","bq":"510","mc":"34012.01277(Crs)","isdc":"18.77872
 (Crs)","name":"sf","tbq":"76497","oi":null,"yh":"1801.25","e":"nse_cm","sp":"1800.90","op":"1814.00","c": "1811.20",
 "to":"145093696.35","ut":"31-Aug-2017 11:32:01","h":"1817.55","v":"80391","nc":"- 00.62","ap":"1804.85","yl":"1800.00","ucl":null,"toi":"16654000" }]

 `
const OrderFeedReq =
    JSON.stringify({
        "user-id": "Your_client_code",
        "status-code": "200",
        "order-status": "AB00",
        "error-message": "",
        "orderData": {
            "variety": "",
            "ordertype": "",
            "ordertag": "",
            "producttype": "",
            "price": 0.0,
            "triggerprice": 0.0,
            "quantity": "0",
            "disclosedquantity": "0",
            "duration": "",
            "squareoff": 0.0,
            "stoploss": 0.0,
            "trailingstoploss": 0.0,
            "tradingsymbol": "",
            "transactiontype": "",
            "exchange": "",
            "symboltoken": "",
            "instrumenttype": "",
            "strikeprice": 0.0,
            "optiontype": "",
            "expirydate": "",
            "lotsize": "0",
            "cancelsize": "0",
            "averageprice": 0.0,
            "filledshares": "",
            "unfilledshares": "",
            "orderid": "",
            "text": "",
            "status": "",
            "orderstatus": "",
            "updatetime": "",
            "exchtime": "",
            "exchorderupdatetime": "",
            "fillid": "",
            "filltime": "",
            "parentorderid": ""
        }
    }, null, 5)

const OrderFeedRes =
    JSON.stringify({
        "user-id": "Your_client_code",
        "status-code": "200",
        "order-status": "AB03",
        "error-message": "",
        "orderData": {
            "variety": "NORMAL",
            "ordertype": "LIMIT",
            "ordertag": "10007712",
            "producttype": "DELIVERY",
            "price": 551.0,
            "triggerprice": 0.0,
            "quantity": "1",
            "disclosedquantity": "0",
            "duration": "DAY",
            "squareoff": 0.0,
            "stoploss": 0.0,
            "trailingstoploss": 0.0,
            "tradingsymbol": "SBIN-EQ",
            "transactiontype": "BUY",
            "exchange": "NSE",
            "symboltoken": "3045",
            "instrumenttype": "",
            "strikeprice": -1.0,
            "optiontype": "",
            "expirydate": "",
            "lotsize": "1",
            "cancelsize": "0",
            "averageprice": 0.0,
            "filledshares": "0",
            "unfilledshares": "1",
            "orderid": "111111111111111",
            "text": "Adapter is Logged Off",
            "status": "rejected",
            "orderstatus": "rejected",
            "updatetime": "25-Oct-2023 23:53:21",
            "exchtime": "",
            "exchorderupdatetime": "",
            "fillid": "",
            "filltime": "",
            "parentorderid": ""
        }
    }, null, 5)


export default class Web extends Component {
    state = {
        header: 'Websocket Order Status',
        data: [{ key: "NSE", api: 'nse_cm ' }, { key: "BSE", api: 'bse_cm ' }, { key: "NFO", api: 'nse_fo ' }, { key: "MCX", api: 'mcx_fo ' }, { key: "NCDEX", api: 'ncx_fo ' }, { key: "CDS", api: 'cde_fo ' },],
        columns: [

            {
                dataField: 'key',
                text: 'Exchange',


            },
            {
                dataField: 'api',
                text: 'Value',


            },

        ],

        taskdata: [{ key: "1", task_name: "cn", description: "To connect to websocket or to async servlet" }, { key: "2", task_name: "hb", description: "Heart beat" }, { key: "3", task_name: "mw", description: "For market watch" }, { key: "4", task_name: "sfi", description: "For subscribing index" }, { key: "5", task_name: "dp", description: "for market depth" }],
        taskcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'task_name',
                text: 'TASK NAME',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        scriptdata: [{ key: "1", param: "name", description: "sf - If value comes as sf it's a script feed" }, { key: "2", param: "tk", description: "script token" }, { key: "3", param: "e", description: "Exchange" }, { key: "4", param: "ltp", description: "Last traded price" }, { key: "5", param: "c", description: "Previous close price" }, { key: "6", param: "nc", description: "% change" }, { key: "7", param: "cng", description: "Change" }, { key: "8", param: "v", description: "Volume" }, { key: "9", param: "bq", description: "Best buy quantity" }, { key: "10", param: "bp", description: "Best buy price" }, { key: "11", param: "bs", description: "Best sell quantity " }, { key: "12", param: "sp", description: "Best sell price" }, { key: "13", param: "ltq", description: " Last traded quantity" }, { key: "14", param: "ltt", description: "Last update time" }, { key: "15", param: "ucl", description: "Upper circuit limit" }, { key: "16", param: "tbq", description: "Total buy quantity" }, { key: "17", param: "mc", description: "Market Capitalization ( issued capital * previous close)" }, { key: "18", param: "lo", description: "Low price" }, { key: "19", param: "yh", description: "Yearly high price" }, { key: "20", param: "op", description: "Open price" }, { key: "21", param: "ts", description: "Trading symbol" }, { key: "22", param: "h", description: "High price" }, { key: "23", param: "lcl", description: "Lower circuit limit" }, { key: "24", param: "tsq", description: "Total Sell quantity" }, { key: "25", param: "ap", description: "Vwap Average Price" }, { key: "26", param: "yl", description: "Yearly Low price" }, { key: "27", param: "h", description: "High price" }, { key: "28", param: "oi", description: "Open interest" }, { key: "29", param: "isdc", description: "Issued capital" }, { key: "30", param: "to", description: "Issued capital" }, { key: "31", param: "toi", description: "total open interest" }, { key: "32", param: "lter", description: "Low trade execution range" }, { key: "33", param: "hter", description: "High trade execution range" }, { key: "34", param: "setltyp", description: "Settlement type" }],
        scriptcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],
        indexdata: [{ key: "1", param: "name", description: "if - If value comes as \"if\" it's a index feed" }, { key: "2", param: "tk", description: "index token" }, { key: "3", param: "e", description: "Exchange" }, { key: "4", param: "ic", description: "index close value" }, { key: "5", param: "nc", description: "% change" }, { key: "6", param: "cng", description: "Change" }, { key: "7", param: "iv", description: "index value" }, { key: "8", param: "tvalue", description: "Update time" }, { key: "9", param: "ihv", description: "Index high value" }, { key: "10", param: "ilv", description: "Index low value" }, { key: "11", param: "iov", description: "Index open value" }],
        indexcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        heartdata: [{ key: "1", param: "ak", description: "ok/nk" }, { key: "2", param: "msg", description: "heartbeat" }, { key: "3", param: "task", description: "hb" }],
        heartcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        connectdata: [{ key: "1", param: "ak", description: "ok/nk" }, { key: "2", param: "msg", description: "connected" }, { key: "3", param: "task", description: "cn" }],
        connectcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        timedata: [{ key: "1", param: "name", description: "tm" }, { key: "2", param: "tvalue", description: "Time" }],
        timecolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],

        marketdata: [{ key: "1", param: "name", description: "dp" }, { key: "2", param: "bp", description: "Best Buy Price 1" }, { key: "3", param: "sp", description: "Best Sell Price 1" }, { key: "4", param: "bq", description: "Best buy quantitiy 1" }, { key: "5", param: "bs", description: " Best sell quantity 1" }, { key: "6", param: "bno", description: "Best Buy no of orders 1 " }, { key: "7", param: "sno", description: "Best Sell no of orders 1" }, { key: "8", param: "bp1", description: "Best Buy Price 2" }, { key: "9", param: "sp1", description: "Best Sell Price 2" }, { key: "10", param: "bq1", description: "Best buy quantity 2" }, { key: "11", param: "bs1", description: "Best sell quantity 2" }, { key: "12", param: "bno1", description: "Best Buy no of orders 2" }, { key: "13", param: "sno1", description: " Best Sell no of orders 2 " }, { key: "14", param: "bp2", description: "Best Buy Price 3" }, { key: "15", param: "sp2", description: "Best Sell Price 3" }, { key: "16", param: "bq2", description: "Best buy quantitiy 3" }, { key: "17", param: "bs2", description: "Best buy quantitiy 3" }, { key: "18", param: "bno2", description: "Best Buy no of orders 3" }, { key: "19", param: "sno2", description: "Best Sell no of orders 3" }, { key: "20", param: "bp3", description: "Best Buy Price 4" }, { key: "21", param: "sp3", description: " Best Sell Price 4" }, { key: "22", param: "bq3", description: "Best buy quantitiy 4" }, { key: "23", param: "bs3", description: "Best buy quantitiy 4" }, { key: "24", param: "bno3", description: "Best Buy no of orders 4" }, { key: "25", param: "sno3", description: "Best Sell no of orders 4" }, { key: "26", param: "bp4", description: "Best Buy Price 5" }, { key: "27", param: "sp4", description: "Best Sell Price 5" }, { key: "28", param: "bq4", description: "Best buy quantitiy 5 " }, { key: "29", param: "bs4", description: "Best sell quantity 5 " }, { key: "30", param: "bno4", description: "Best Buy no of orders 5 " }, { key: "31", param: "sno4", description: "Best Sell no of orders 5 " }, { key: "32", param: "tbq", description: "Total buy quantity " }, { key: "33", param: "tsq", description: "Total sell quantity " }, { key: "34", param: "lter", description: "Lower trade execution range" }, { key: "35", param: "hter", description: "High trade execution range" }],
        marketcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'param',
                text: 'PARAMETER',
            },
            {
                dataField: 'description',
                text: 'DESCRIPTION',
            }
        ],
        errordata: [{ key: "1", error_code: "401", description: "If the AUTHORIZATION_TOKEN is invalid, you will receive a 401 Response Code." }, { key: "2", error_code: "403", description: "If the AUTHORIZATION_TOKEN is expired, you will receive a 403 Response Code." }, { key: "3", error_code: "429", description: "If you breach the connection limit, you will receive a 429 Response Code." }],
        errorcolumns: [
            {
                dataField: 'key',
                text: 'Sr. No',
            },
            {
                dataField: 'error_code',
                text: 'Error Code',
            },
            {
                dataField: 'description',
                text: 'Description',
            }
        ],
        fielddata: [
            { key: "1", error_code: "AB00", description: "after-successful connection" },
            { key: "2", error_code: "AB01", description: "open" },
            { key: "3", error_code: "AB02", description: "cancelled" },
            { key: "4", error_code: "AB03", description: "rejected" },
            { key: "5", error_code: "AB04", description: "modified" },
            { key: "6", error_code: "AB05", description: "complete" },
            { key: "7", error_code: "AB06", description: "after market order req received" },
            { key: "8", error_code: "AB07", description: "cancelled after market order" },
            { key: "9", error_code: "AB08", description: "modify after market order req received" },
            { key: "10", error_code: "AB09", description: "open pending" },
            { key: "11", error_code: "AB10", description: "trigger pending" },
            { key: "12", error_code: "AB11", description: "modify pending" },
        ],

        fieldcolumns: [{
            dataField: 'key',
            text: 'Sr. No',
        },
        {
            dataField: 'error_code',
            text: 'Status Code',
        },
        {
            dataField: 'description',
            text: 'Description',
        }]


    }
    //latest code
    componentDidMount() {
    }
    render() {
        const { header, data, columns, taskdata, taskcolumns, scriptcolumns, scriptdata, indexdata, indexcolumns, heartdata, heartcolumns, connectdata, connectcolumns, timedata, timecolumns, marketdata, marketcolumns, errordata, errorcolumns, fielddata, fieldcolumns } = this.state
        return (
            <div className='container-fluid font mb-5' id="/docs/WebSocketOrderStatus">
                {/* <div class="title doc-row">
                    <div class="doc-left">
                        <h1 id="response-structure">{header}</h1>
                        <p>The WebSocket API uses WebSocket protocol to establish a single long standing TCP connection after an HTTP handshake to receive streaming quotes. To connect to the SmartAPI WebSocket API, you will need a WebSocket client library in your choice of programming language. You can subscribe for instruments on a single WebSocket connection and receive live quotes for them. </p>
                        <p>To receive quotes for instruments across all exchanges during live market hours, the WebSocket API is the best to use in terms of speed, latency, resource consumption and bandwidth. A quote consists of fields such as open, high, low, close, last traded price, 5 levels of bid/offer market depth data etc. </p>
                        <p><strong style={{ fontWeight: "bolder" }}>Note:</strong> Exchange Mapping- If your exchange is ‘’NSE’’ then the value should be something like this ‘’nse_cm’’. </p>
                        <BootstrapTable

                            hover
                            keyField='id'
                            data={data}
                            columns={columns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />
                    </div>
                </div> */}
                <div class="title doc-row">
                    <div class="doc-left">
                        <h1 id="Websocket-order">{header}</h1>
                        <p>Websocket Order Status API will function in providing order status updates through websocket server connection and provide Order responses similar to the one received in Postback/Webhook. The connection can be made to the Websocket Server API using below url and input parameters. </p>
                        <p>To connect to the WebSocket, clients need to use the following URL:- </p>
                        <pre>
                            <code data-language="html">
                                wss://tns.angelone.in/smart-order-update
                            </code>
                        </pre>
                        <p className="mt-2">In the WebSocket connection request, include the following Header key:-  </p>
                        <pre>
                            <code data-language="html">
                                Authorization: Bearer AUTHORIZATION_TOKEN
                            </code>
                        </pre>
                        <h4 className="mt-2">Please note that there is a connection limit for each user. Each client code is limited to 3 connections.</h4>
                        <p>Initial Response: Upon successfully connecting to the WebSocket, you will receive an initial response in the following format: </p>
                        <pre >
                            <code data-language="json" >
                                {OrderFeedReq}
                            </code>
                        </pre>
                        <h4 className="mt-2">The order-status field can have values like:</h4>
                        <BootstrapTable
                            hover
                            keyField='id'
                            data={fielddata}
                            columns={fieldcolumns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />
                        <h4 className="mt-2">Client Interaction:</h4>
                        <p>The client application should periodically send a ping message to the server and expect a pong message from the server every 10 seconds. This helps check the liveliness of the WebSocket connection.</p>
                        <h4>Sample Response:</h4>
                        <p>Here's an example of a response you might receive from the WebSocket:</p>
                        <pre >
                            <code data-language="json" >
                                {OrderFeedRes}
                            </code>
                        </pre>
                        <h2>Error Codes:</h2>
                        <BootstrapTable
                            hover
                            keyField='id'
                            data={errordata}
                            columns={errorcolumns}
                            wrapperClasses={'react-bootstrap-table1'}
                            headerClasses="font"
                        />

                        <div class="row">
                            <div class="col-md-6">
                                <i class=" changePrevious-Button fas fa-chevron-circle-left" title="Previous" onClick={() => changePath('/docs/WebSocket2')}></i>
                                {/* <input  style={{float: 'left'}} type="button" className="btn btn-primary btn-lg m-t-5" onClick={()=>changePath('/docs/Publisher')} value='<< Previous'/> */}
                            </div>
                            <div class="col-md-6">
                                <i class=" changeNext-Button fas fa-chevron-circle-right" title="Next" onClick={() => changePath('/docs/Instruments')}></i>
                                {/* <input style={{float: 'right'}} type="button" className="btn btn-primary btn-lg m-t-5" onClick={()=>changePath('/docs/Instruments')} value='Next >>'/> */}
                            </div>
                        </div>
                    </div>
                    {/* <div class="doc-right"></div> */}
                </div>
            </div>
        );
    }
}
